import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';
// ('../../../services/apiServices/dailySessionNotes/dailySessionNotes');
const {
  REQUEST_SUBMIT_E_SIGN,
  SUCCESS_SUBMIT_E_SIGN,
  LOADING_SUBMIT_E_SIGN,
  FAILURE_SUBMIT_E_SIGN,
} = dailySessionNotes;
function* submitEsign(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_SUBMIT_E_SIGN });

    const response = yield call(dailySessionNotesService.submitESign, action.payload);
    if (response?.status === 200) {
      //  THIN-7866: submitting a DSN for e-sign used to branch here — a falsy `isFeatureToggle`
      //  fetched a Jotform sign template and the caller opened the Jotform iframe. Every document
      //  is signed with the Reform signature flow now, so there is no second branch: the caller
      //  opens the Reform sign modal off SUCCESS.
      yield put({ type: SUCCESS_SUBMIT_E_SIGN, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_SUBMIT_E_SIGN, payload: error });
  }
}

function* submitEsignSaga() {
  yield takeEvery(REQUEST_SUBMIT_E_SIGN, submitEsign);
}

export default submitEsignSaga;
